// extracted by mini-css-extract-plugin
export var stateList = "vcl-subroutine-module--stateList--8929b";
export var stateNode = "vcl-subroutine-module--stateNode--ae199";
export var stateTransitions = "vcl-subroutine-module--stateTransitions--2f5a3";
export var statesBefore = "vcl-subroutine-module--statesBefore--069bb";
export var statesThis = "vcl-subroutine-module--statesThis--72da1";
export var subName = "vcl-subroutine-module--subName--3b90c";